import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import reducers from './redux/reducers';
import { createStore, applyMiddleware, compose } from 'redux';
import Router from './router';
import { isEmpty as _isEmpty } from 'lodash-es';
import { ApplicationError } from 'utilities/ErrorHandlling/ErrorHandlling';
import ErrorBoundary from 'components/ErrorBoundary';
import { onCheckLogin } from 'redux/UserManagement/UserManagement.action';
import 'localizationService/i18n';
import './assets/styles/global.scss';
import './assets/styles/antd.min.css';
import { datadogRum } from '@datadog/browser-rum';

const middlewares = [thunk];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(reducers(), composeEnhancers(applyMiddleware(...middlewares)));

// Dispatch login check
store.dispatch(onCheckLogin());

const root = createRoot(document.getElementById('root'));
if (
  process.env.NODE_ENV === 'production' &&
  !_isEmpty(process.env.REACT_APP_DATADOG_APPLICATION_ID) &&
  !_isEmpty(process.env.REACT_APP_DATADOG_CLIENT_TOKEN)
) {
  datadogRum.init({
    applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID,
    clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    service: 'graas-frontend-',
    env: process.env.NODE_ENV,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input'
  });
  datadogRum.startSessionReplayRecording();
}

try {
  root.render(
    // <React.StrictMode> {/* ✅ Wrap in StrictMode for better debugging */}
    <Suspense fallback={<></>}>
      <Provider store={store}>
        <ErrorBoundary>
          <Router />
        </ErrorBoundary>
      </Provider>
    </Suspense>
    // </React.StrictMode>
  );
} catch (error) {
  console.log('in error');
  throw new ApplicationError({
    error: error,
    customMessage: 'Something went wrong while starting application.'
  });
}
